'use strict';

function regexMatcher(reg) {
  reg = RegExp(reg);
  return function(el) {
    return reg.test(el);
  };
}

module.exports = regexMatcher;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/regexMatcher.js
// module id = 457
// module chunks = 0